function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createContext, useContext, useMemo } from 'react';
import { usePartial } from '@okee-uikit/react-hooks';
import { isArray, isAssigned, isFunction, isObject } from '@okee-uikit/react-utils';

function getCreatePredicateMap(columns) {
  var map = {};
  var ids = [];

  var walk = function walk(array) {
    return array.forEach(function (_ref) {
      var id = _ref.id,
          children = _ref.children,
          _ref$filterOptions = _ref.filterOptions;
      _ref$filterOptions = _ref$filterOptions === void 0 ? {} : _ref$filterOptions;
      var createPredicate = _ref$filterOptions.createPredicate;

      if (isArray(children)) {
        walk(children);
      }

      if (isFunction(createPredicate) && !isAssigned(map[id])) {
        map[id] = createPredicate;
        ids.push(id);
      }
    });
  };

  walk(columns);
  return [map, ids];
}

function filter(rowInfos, recursive, predicates) {
  if (predicates.length === 0) {
    return rowInfos;
  }

  var result = [];
  rowInfos.forEach(function (rowInfo, index) {
    var children = rowInfo.children;
    var flag = predicates.every(function (p) {
      return p(rowInfo);
    });

    if (flag) {
      if (recursive && children) {
        result.push(_objectSpread(_objectSpread({}, rowInfo), {}, {
          children: filter(children, true, predicates)
        }));
        return;
      }

      result.push(rowInfo);
    }
  });
  return result;
}

export function useTableFilterInit(rowInfos, columns, options) {
  var enable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : isAssigned(options);

  var _ref2 = options || {},
      _ref2$process = _ref2.process,
      process = _ref2$process === void 0 ? false : _ref2$process,
      _ref2$recursive = _ref2.recursive,
      recursive = _ref2$recursive === void 0 ? false : _ref2$recursive,
      value = _ref2.value,
      onChange = _ref2.onChange,
      _ref2$defaultValue = _ref2.defaultValue,
      _defaultValue = _ref2$defaultValue === void 0 ? value : _ref2$defaultValue,
      controlled = _ref2.controlled;

  var _useMemo = useMemo(function () {
    return getCreatePredicateMap(columns);
  }, [columns]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      map = _useMemo2[0],
      ids = _useMemo2[1];

  var _usePartial = usePartial({
    value: value,
    onChange: onChange,
    defaultValue: function defaultValue() {
      var initialValue = isFunction(_defaultValue) ? _defaultValue() : _defaultValue;

      if (!isObject(initialValue)) {
        return {};
      }

      return initialValue;
    },
    controlled: controlled
  }),
      _usePartial2 = _slicedToArray(_usePartial, 2),
      innerValue = _usePartial2[0],
      actions = _usePartial2[1];

  var resolvedRowInfos = useMemo(function () {
    if (!process) {
      return rowInfos;
    }

    var allPredicates = [];
    ids.forEach(function (id) {
      var value = innerValue[id];
      var create = map[id];

      if ((isArray(value) && value.length > 0 || isAssigned(value)) && create) {
        var predicate = create(value);

        if (isFunction(predicate)) {
          allPredicates.push(predicate);
        }
      }
    });
    return filter(rowInfos, recursive, allPredicates);
  }, [rowInfos, columns, innerValue, process, recursive]);
  return enable && [resolvedRowInfos, innerValue, actions] || [rowInfos, undefined, undefined];
}
export var FilterContext = createContext({
  state: undefined,
  actions: undefined
});
export var useTableFilter = function useTableFilter() {
  return useContext(FilterContext);
};